<template>
  <div class="page" style="padding: 0">
    <el-tabs
      tab-position="left"
      type="border-card"
      @tab-click="handleClick"
      v-model="active"
    >
      <template v-for="(item, index) in tabList">
        <template v-if="item.isShow">
          <el-tab-pane
            :name="item.path"
            :label="item.title"
            :key="index"
          ></el-tab-pane>
        </template>
      </template>
      <router-view />
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "/demo/demoIndex",
      tabList: [
        {
          title: "待计算/确认",
          path: "/demo/demoIndex",
          isShow: true,
        },
        {
          title: "待发放",
          path: "/demo/unconfirmed2",
          isShow: true,
        },
        {
          title: "已发放",
          path: "/demo/unconfirmed1",
          isShow: true,
        },
      ],
    };
  },
  created() {
    this.active = this.$route.path;
    // this.queryTabItemAuth()
  },
  methods: {
    handleClick(tab) {
      const current = tab.index;
      this.$router.push(this.tabList[current].path);
    },
  },
};
</script>

<style lang="less"></style>
